import React, { useEffect, useState } from 'react';
import { ReactComponent as ArrowDownIcon } from "assets/icons/ico_arrow_down_green.svg";
import CheckBox from '../checkbox';
import { useTranslation } from 'react-i18next';

const DropDownMultiSelector = ({ options, onOptionSelected, title }) => {

    const [showDropDown, setShowDropDown] = useState(false);
    const [numberOfOptionsSelected, setNumberOfOptionsSelected] = useState(options.length);
    const { t } = useTranslation();

    useEffect(() => {
        const numberOfOptionsSelected = options.filter((option) => { return option.isChecked }).length;
        setNumberOfOptionsSelected(numberOfOptionsSelected);
    }, [options])

    return (
        <div className="flex flex-col relative">
            {title &&
                <div className="flex relative items-center">
                    <span className="text-base font-medium pb-1">{title}</span>
                </div>
            }
            <button onClick={(e) => { e.preventDefault(); setShowDropDown(!showDropDown); }} className="flex md:min-w-[320px] min-w-full items-center relative bg-airpark-gray-300 rounded-xl h-11 appearance-none pl-6">
                <div className="flex w-full justify-between items-center pr-10">
                    <span>{t('generic.filter')}</span>
                    {numberOfOptionsSelected > 0 &&
                        <span>({numberOfOptionsSelected})</span>
                    }
                </div>
                <div className="flex absolute right-4 inset-y-0 my-auto pointer-events-none h-5 w-5 items-center justify-center">
                    <ArrowDownIcon />
                </div>
            </button>
            {showDropDown && options &&
                <>
                    <div className="fixed inset-0 z-10" onClick={(e) => { e.preventDefault(); setShowDropDown(false); }} />
                    <ul className={`flex flex-col z-20 absolute ${title ? 'top-20' : 'top-12'} p-3 bg-white shadow min-w-[320px] w-full rounded-xl`}>
                        {options.map((option, i) => {
                            return (
                                <li key={i} className="flex mb-2 last:mb-0">
                                    <button className="flex" onClick={(e) => { e.preventDefault(); onOptionSelected(option); }}>
                                        <div className="flex pointer-events-none">
                                            <CheckBox isChecked={option.isChecked} />
                                            <span className="ml-2">{option.title}</span>
                                        </div>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                </>
            }
        </div>
    );
};

export default DropDownMultiSelector;